var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHv71(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 290.6 165.6",
    style: {
      enableBackground: "new 0 0 290.6 165.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;stroke:#002D59;stroke-width:1.1;}\n\t.st1{fill:#002D59;}\n\t.st2{fill:#FFD500;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M50.4,60.1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.2,4.3l36.5,0l9.7,11.1V4.3h37.1l40.4,45.2l7.2-11.7h20l-11.8-13.4l12.3-20.1h97.2l33.8,38.2v89.4 c0,0-23.3,0.1-23.7,0c-0.4-0.1-34.3-39.1-34.3-39.1l-24.5,39.1h-21.7l-11.2-12.7l-25.4,41l-24.8-28.3h-40l-6.7-7.7v7.7H35l-30.7-35 V4.3z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 55.1,
    y: 9,
    className: "st1",
    width: 27.8,
    height: 28.9
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "55.1,60.1 72.4,60.1 82.9,75.6 82.9,90.4 55.1,90.4  "
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "8.9,9 36.1,9 36.1,42.5 101.6,42.6 120.4,70.5 137.6,42.5 171.8,42.5 121.5,124.5 74.8,55.5  36.1,55.5 36.1,90.4 8.9,90.4  "
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "158.2,9 222.6,9 172.7,90.4 157.1,90.4 198,23.6 149.3,23.6  "
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 233.3,
    y: 9,
    className: "st1",
    width: 14.9,
    height: 81.4
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "40.8,11.5 50.4,22.5 50.4,37.9 40.8,37.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "87.5,10.7 125.3,53.7 120.3,61.9 104,37.9 87.5,37.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "40.8,60.1 50.4,60.1 50.4,95.1 87.5,95.1 87.5,82.6 117.7,127.3 82.9,127.2 69.7,111.8 69.7,127.2  37.1,127.2 8.9,95.1 40.8,95.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "152.8,28.2 189.8,28.2 148.7,95.1 175.2,95.1 228.6,8 228.6,83.6 201.6,127.2 184.6,127.2  170.7,111.3 145.2,152.4 124.4,128.6 180.1,37.8 161.3,37.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "252.8,11.3 282,44.5 282,127.2 265.1,127.2 236.8,95.1 252.8,95.1  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHv71);
export default __webpack_public_path__ + "static/media/hv71.d7535202806dc50a944475a100aa356a.svg";
export { ForwardRef as ReactComponent };